import { DataModel } from "common/models/utility-models/base-model";

export class ReportsNavigationModel extends DataModel {
    icon: string = '';
    created?: string = '';
    is_delete?: number = 0;
    modified?: string = '';
    orderNumber?: number = null;
    type?: string = '';
    typeFlag?: number = null;
    routeUrl?: string = '';
    show?: boolean = true;;
}